import { render, staticRenderFns } from "./ProductPaymentPlansList.vue?vue&type=template&id=34de9904&scoped=true&"
import script from "./ProductPaymentPlansList.vue?vue&type=script&lang=js&"
export * from "./ProductPaymentPlansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de9904",
  null
  
)

export default component.exports